"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TitleSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `Title`.
 */ const TitleSkeleton = (param)=>{
    let { animation = 'pulse', className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.TITLE_SKELETON),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
            variant: "rectangular",
            animation: animation
        })
    });
};
exports.TitleSkeleton = TitleSkeleton;
